import { Epic } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';
import { handleError, handlers } from '@alycecom/services';

import { IBranding } from '../../types/Branding.types';
import { ICodeRequestParams } from '../types/Request.types';

import { fetchBranding } from './branding.actions';

const getBrandingUrl = ({ hashId, isCode = false }: ICodeRequestParams): string => {
  const codePart = isCode ? 'code/' : '';
  return `/api/recipient/${codePart}${hashId}/styling`;
};

export const fetchBrandingEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(fetchBranding.pending),
    switchMap(({ payload }) =>
      apiService.get(getBrandingUrl(payload)).pipe(
        map((response: IBranding) => fetchBranding.fulfilled(response)),
        catchError(handleError(handlers.handleAnyError(fetchBranding.rejected()))),
      ),
    ),
  );

export const brandingEpics = [fetchBrandingEpic];
